$(document).ready(function () {
    $('[data-bs-toggle]').on('click', function() {
        var modal = $(this).attr('data-bs-target');
        setModalBehaviour(modal);
      });

      $('.btn-close-modal').on('click', function() {
        var modal = $('.modal-wrapper.show');
        closeBSModal(modal);
      });

      function setModalBehaviour(modal) {
        if($('body').hasClass('modal-open')) {
          closeBSModal(modal);
        } else {
          openBSModal(modal);
        }
      }
    
      function openBSModal(modal) {
        $('body').append('<div class="modal-backdrop" id="modal-backdrop-trigger">&nbsp;</div>');
        $('body').addClass('modal-open');
        window.addEventListener("click", (event) => {
          console.log('clicou outside', event.target.id, modal);
          if(event.target.id == modal.substr(1, modal.length - 1)) {
            closeBSModal(modal);
          }
        });
        setTimeout(() => {
          $('.modal-backdrop').addClass('show');
          $(modal).addClass('show');
        }, 50);
        $(modal).css({
          'display' : 'block'
        });
      }
      function closeBSModal(modal) {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').removeClass('show');
        $(modal).find('form').trigger('reset');
        setTimeout(() => {
          $('.modal-backdrop').remove();
        }, 200);
        $(modal).removeClass('show');
        $(modal).css({
          'display' : 'none'
        });
      }
});